import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pb0001',
    ecrans: ['00-2']
});
